
import { ChallengeSettings } from "../../../model/ChallengeSettings.model";
import { computed } from "vue";
import { Options } from "vue-class-component";
import Base from "../../../components/base/Base.vue";
import ListDetailSettings from "../index";
import { MutationTypes } from "@/store/mutations";
import { ScreenType } from "../../../enum/screen.type";
@Options({
  components: ListDetailSettings
})
export default class ListTemplate extends Base {
  public ListSettings = computed<ChallengeSettings[]>(
    () => this.store.getters.getSettingChallenges
  ).value;

  settingsSelect: ChallengeSettings = {
    id: 0,
    name: "",
    description: "",
    settings: [],
    challengeName: "",
    challengeDescription: "",
    questions: [],
    imageChallenge: ""
  };
  challengeType = "quiz";

  created() {
    this.settingsSelect = this.ListSettings.find(
      (s: any) => s.name.toLowerCase() === this.challengeType
    ) as any;
  }

  onRowSelect(event: any) {
    this.settingsSelect = event.data;
    this.challengeType = event.data.name.toLowerCase();
    this.$el
      .getElementsByClassName("templates")[0]
      .scrollIntoView({ behavior: "smooth" });
  }

  openCreateChallenger() {
    this.store.commit(
      MutationTypes.SET_CHALLENGES_SETTING_SELECTED,
      this.settingsSelect
    );
    this.redirectTo(ScreenType.createChallenge);
  }
}
